import _ from "lodash";
import * as Draft from "src/scenes/orgAdmin/formTemplates/types/draft";
import * as GQL from "src/types/graphql";
import { SectionFormType } from "./SectionFormDialog";

export const createNewSection = (values: SectionFormType): Draft.NewSection => {
  const base = {
    id: window.crypto.randomUUID(),
    type: values.type,
    title: values.title,
    description: values.description,
    key: values.key,
    isDraft: true,
    isNew: true,
    familyEditableStatuses:
      values.familyEditableStatuses?.map((status) => status.id) ?? [],
  };

  const permissionLevel = _.isEmpty(values.permissionLevel)
    ? null
    : values.permissionLevel;

  switch (values.type) {
    case GQL.form_template_section_type_enum.SchoolRankingSection:
      return {
        ...base,
        permissionLevel: null,
        minSchools: values.minSchools,
        maxSchools: values.maxSchools,
        exploreUrl: values.exploreUrl,
        rankingEnabled: values.rankingEnabled,
        schoolRankingFormSectionId: window.crypto.randomUUID(),
      } as Draft.NewSchoolRanking;
    case GQL.form_template_section_type_enum.DisclaimerSection:
      return {
        ...base,
        permissionLevel,
        disclaimerFormSectionId: window.crypto.randomUUID(),
        disclaimer: "",
      } as Draft.NewDisclaimer;
    case GQL.form_template_section_type_enum.PreRankingSection:
      return {
        ...base,
        permissionLevel: null,
        questions: [],
      } as Draft.NewSection;
    case GQL.form_template_section_type_enum.GeneralSection:
      return {
        ...base,
        permissionLevel,
        questions: [],
      } as Draft.NewSection;
    default:
      throw new Error(`Unsupported section type: ${values.type}`);
  }
};
